import { type ClusterGroup } from "~/features/selectionAssistant/bearing/types";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";

function getApiUrl(): string {
  return occUrl("/search/clustergroups?selectionGroup=ROTARY");
}

export interface BearingClusterGroupListResponseDTO {
  groups?: BearingClusterGroupDTO[];
}

type BearingClusterGroupDTO = Omit<ClusterGroup, "clusterItems"> & {
  clusterItems?: ClusterGroup["clusterItems"];
};

export function getTileDisplayData(): Promise<ClusterGroup[]> {
  return occFetch(getApiUrl()).then(async (response) => {
    if (!response.ok) {
      return [];
    }
    const dto = (await response.json()) as BearingClusterGroupListResponseDTO;
    return (dto.groups ?? []).map((group) => ({
      ...group,
      clusterItems: group.clusterItems ?? [],
    }));
  });
}
